export default function () {
  return {
    showModal: false,
    youTubeURL: '',
    heroVideo(videoUrl) {
      const url = new URL(videoUrl);
      const urlParams = new URLSearchParams(url.search);
      const videoId = urlParams.get('v');
      const youTubeURL = `https://www.youtube.com/embed/${videoId}?controls=0&autoplay=1&modestbranding=1&rel=0`;
      if (videoId === null) {
        return false;
      }
      this.youTubeURL = youTubeURL;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.youTubeURL = '';
    },
  };
}